import { call, put, takeEvery, select, delay } from "redux-saga/effects";
import * as vehicleCardActions from "../actions/vehicleCard";
import {
  getVehicleByIdRequest,
  createVehicleRequest,
  updateVehicleRequest,
  updateVehicleStatusRequest
} from "../../api/vehicleCard";
import history from "../../../../common/history";
import { errorProcessing } from "../../../Employees/api/errorProcessing";
import { vehicleErrorResponse } from "../../api/vehicleCard/dataAdjustment";
import showSuccessWindow from "../../../../common/components/successPopup/successPopup";
import {
  successCreateVehicle,
  successUpdateVehicle,
  successUpdateVehicleStatus
} from "../../components/vehicleCard/popup/success";
import { message } from "antd";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

const getErrors = state => {
  return {
    errors:
      state.Transport &&
      state.Transport.vehicleCard &&
      state.Transport.vehicleCard.errors,
    errorMessage:
      state.Transport &&
      state.Transport.vehicleCard &&
      state.Transport.vehicleCard.errorMessage
  };
};

function* getVehicleByIdSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getVehicleByIdRequest,
        activeProfileId,
        action.payload
      );
      yield put(vehicleCardActions.getVehicleByIdSuccess(response));
    } catch (err) {
      const errData = errorProcessing(err);
      if (errData.statusCode === 404) {
        history.push("/vehicles");
      }
      yield put(vehicleCardActions.getVehicleByIdError(errData));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(vehicleCardActions.getVehicleById(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* createVehicleSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  let errors = yield select(getErrors);
  if (activeProfileId) {
    try {
      const response = yield call(
        createVehicleRequest,
        activeProfileId,
        action.payload
      );
      yield put(vehicleCardActions.createVehicleSuccess(response));
      showSuccessWindow(
        successCreateVehicle(
          response.brandName,
          response.registerSign,
          response.registerRegion
        )
      );
      if (errors) {
        yield put(vehicleCardActions.clearErrors());
      }
      history.push("/vehicles");
    } catch (err) {
      let errData = errorProcessing(err, vehicleErrorResponse);
      if (errData.message) message.error(errData.message);
      yield put(vehicleCardActions.createVehicleError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* updateVehicleSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  let errors = yield select(getErrors);
  if (activeProfileId) {
    try {
      const response = yield call(
        updateVehicleRequest,
        activeProfileId,
        action.payload
      );
      yield put(vehicleCardActions.updateVehicleSuccess(response));
      showSuccessWindow(
        successUpdateVehicle(
          response.brandName,
          response.registerSign,
          response.registerRegion
        )
      );
      if (errors) {
        yield put(vehicleCardActions.clearErrors());
      }

      // history.push('/vehicles');
    } catch (err) {
      let errData = errorProcessing(err, vehicleErrorResponse);
      if (errData.message) message.error(errData.message);
      yield put(vehicleCardActions.updateVehicleError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* updateVehicleStatusSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        updateVehicleStatusRequest,
        activeProfileId,
        action.payload.vehicleId,
        action.payload.status
      );
      yield put(vehicleCardActions.updateVehicleStatusSuccess(response));
      showSuccessWindow(
        successUpdateVehicleStatus(response.name, response.statusKey)
      );
      history.push("/vehicles");
    } catch (err) {
      let errData = errorProcessing(err);
      if (errData.message) message.error(errData.message);
      yield put(vehicleCardActions.updateVehicleStatusError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

export function* vehicleCardConfigWatcher() {
  yield takeEvery(
    vehicleCardActions.getVehicleById.toString(),
    getVehicleByIdSaga
  );
  yield takeEvery(
    vehicleCardActions.createVehicle.toString(),
    createVehicleSaga
  );
  yield takeEvery(
    vehicleCardActions.updateVehicle.toString(),
    updateVehicleSaga
  );
  yield takeEvery(
    vehicleCardActions.updateVehicleStatus.toString(),
    updateVehicleStatusSaga
  );
}
